import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from './admindashboard';
import AdminLogin from './adminlogin';
import AdminProtectedRoute from './adminprotectedroute';
import FormTreeEditor from '../form-editor/form_tree_editor';
import LLMProviderManagement from './llmprovidermanagement';
import AdminContentNavigator from './AdminContentNavigator';
import QARichContentPage from './QARichContentPage';

const AdminMainRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      
      <Route path="/" element={
        <AdminProtectedRoute>
          <AdminDashboard />
        </AdminProtectedRoute>
      } />
      
      <Route path="/dashboard" element={
        <AdminProtectedRoute>
          <AdminDashboard />
        </AdminProtectedRoute>
      } />
      
      <Route path="/form-tree-editor" element={
        <AdminProtectedRoute>
          <FormTreeEditor />
        </AdminProtectedRoute>
      } />

      <Route path="/llm-providers" element={
        <AdminProtectedRoute>
          <LLMProviderManagement />
        </AdminProtectedRoute>
      } />

      <Route path="/content-editor" element={
        <AdminProtectedRoute>
          <AdminContentNavigator />
        </AdminProtectedRoute>
      } />

      <Route path="/qa-rich-content/:qaId" element={
        <AdminProtectedRoute>
          <QARichContentPage />
        </AdminProtectedRoute>
      } />
    </Routes>
  );
};

export default AdminMainRoutes;